export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11383.391ea37d.jpg";